module.exports = __webpack_public_path__ + "img/rctRcm.d56caecd.png";